import "core-js/modules/es.string.sub.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "notice-form"
  }, [_c("a-form-model", {
    attrs: {
      form: _vm.form,
      model: _vm.value
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.status")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.status,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "status", $$v);
      },
      expression: "value.status"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.textColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textColor", $$v);
      },
      expression: "value.textColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.noticeLink"),
      layout: "vertical"
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("form.noticeLink"),
      rows: 5
    },
    model: {
      value: _vm.value.pathLink,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pathLink", $$v);
      },
      expression: "value.pathLink"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.mainTitle")
    }
  }, [_vm._l(_vm.langList, function (lang, li) {
    return [_c("a-row", {
      key: li,
      staticClass: "form-row"
    }, [_c("a-form-model-item", {
      attrs: {
        label: lang.langName,
        prop: "main.title." + lang.langId,
        rules: [{
          required: !!lang.required,
          message: _vm.$t("form.mainTitle_placeholder"),
          trigger: "change"
        }]
      }
    }, [_c("a-textarea", {
      attrs: {
        placeholder: _vm.$t("public.enterPlease"),
        rows: "5",
        maxLength: 1000
      },
      model: {
        value: _vm.value.main.title[lang.langId],
        callback: function callback($$v) {
          _vm.$set(_vm.value.main.title, lang.langId, $$v);
        },
        expression: "value.main.title[lang.langId]"
      }
    })], 1)], 1)];
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.main.fontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value.main, "fontSize", $$v);
      },
      expression: "value.main.fontSize"
    }
  })], 1)], 2), _c("Card", {
    attrs: {
      title: _vm.$t("form.subTitle")
    }
  }, [_c("Title", {
    model: {
      value: _vm.value.sub.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value.sub, "title", $$v);
      },
      expression: "value.sub.title"
    }
  }), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.sub.fontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value.sub, "fontSize", $$v);
      },
      expression: "value.sub.fontSize"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };